
<div>
<!--<app-left-menu></app-left-menu>-->
  <mat-card class="mat-elevation-z8">
    <div class="row">
      <div class="col"></div>
      <div class="col-1">
        <!--<button mat-raised-button color="primary" (click)="hideTable()">Back</button>-->
      </div>

    </div>
    <form [formGroup]="zone_register_form">
      <div class="form-group">
        <label>Name of the zone<i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <input type="text" class="form-control code_box" formControlName='name'>
      </div>
      <button mat-raised-button color="primary" [disabled]="!zone_register_form.valid" (click)="registerZone()" style="text-transform: capitalize">{{action}}</button>
    </form>
  </mat-card>
</div>

